/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Retrieves and returns a sanitized version of the given data object.
 *
 * This function iterates over the key-value pairs in the provided object
 * and accumulates a new object containing only the keys with non-null and non-'null' values.
 * The resulting object represents sanitized data for use in requests or other operations.
 *
 * @template T - The type of the object being processed.
 * @param {T} data - The original data object.
 * @returns {T} A new object containing only valid data.
 */
export const sanitize = <T extends Record<string, any>>(data: T): T => {
  return Object.entries(data).reduce((accumulatedData, [key, value]) => {
    if (value && value !== 'null') {
      accumulatedData[key as keyof T] = value;
    }
    return accumulatedData;
  }, {} as T);
};
